module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0065.jpg?v=f22d5653";